var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"estoque-unidades",class:{ compacto: _vm.compacto }},_vm._l((_vm.saldos),function(item,index){return _c('span',{key:index,class:{ 'estoque-unidades-base': item.base }},[_c('strong',[_vm._v(_vm._s(_vm.formatar(item.saldo)))]),_vm._v(" "+_vm._s(item.unidade))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }